import { ItemShownEvent } from '~/shared/event_subjects'
import GtmEmitter from './gtm_emitter'

export type DataWithName = {
  name: string,
  data: any
}

export default class GtmEmitterState {
  onEnterState (context: GtmEmitter) {
  }

  onPlaceChanged (context: GtmEmitter, e: ItemShownEvent) {
    throw new Error('abstract placeChanged')
  }

  onEnterPage (context: GtmEmitter, pageData: {}) {
    throw new Error('abstract emitPageEnter')
  }

  onEvent (context: GtmEmitter, name: string, data: {} = {}) {
    throw new Error('abstract emitEvent')
  }

  terminate (context: GtmEmitter) {
    throw new Error('abstract terminate')
  }
}
